import { render, staticRenderFns } from "./VConfirmModal.vue?vue&type=template&id=54869ec8&scoped=true"
import script from "./VConfirmModal.vue?vue&type=script&lang=js"
export * from "./VConfirmModal.vue?vue&type=script&lang=js"
import style0 from "./VConfirmModal.vue?vue&type=style&index=0&id=54869ec8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54869ec8",
  null
  
)

export default component.exports